module.exports = __webpack_public_path__ + "media/share_images/trumpet-e6445b2d.svg";